import classNames from 'classnames';
import { type ComponentProps, type ElementRef, forwardRef } from 'react';

export type TreeItemActionProps = ComponentProps<'button'>;

export const TreeItemAction = forwardRef<ElementRef<'button'>, TreeItemActionProps>(
  ({ className, ...restOfProps }, forwardedRef) => {
    return (
      <button
        className={classNames(
          'flex size-6 cursor-pointer items-center justify-center rounded-4 ads:text-icon-emphasis text-gray-12 hover:ads:bg-hover-subtle hover:bg-gray-4',
          className,
        )}
        ref={forwardedRef}
        {...restOfProps}
      />
    );
  },
);

TreeItemAction.displayName = 'TreeItemAction';
